import React, { useState } from 'react'
import { Card, CardContent } from '../../components/ui/card'
import { goToHomePage, hideLoader, showLoader } from '../../helpers/Utils'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { Label } from '../../components/ui/label'
import '../../assets/styleSheets/login.scss'
import { tryForgettingPassword } from '../../services/auth'
import { CDN_URL } from '../../constants/siteConstant'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { mailCheck } from '../../helpers/svgIcons'

const errorStyle = {
  fontSize: '12px',
  color: 'red',
  marginTop: '4px'
}
export default function ForgotPasswordNew () {
  const [steps, setSteps] = useState(1)
  const [emailId, setEmailId] = useState('')
  const [error, setError] = useState(false)
  const navigate = useNavigate()

  const { t } = useTranslation(['auth'])

  const handleChange = (e) => {
    setEmailId(e.target.value)
    if (e.target.value) {
      setError(false)
    }
  }

  const handleSubmit = async () => {
    if (!emailId) {
      setError(true)
      return
    }
    showLoader()
    const response = await tryForgettingPassword(emailId)
    if (response) {
      setSteps(steps + 1)
    }
    hideLoader()
  }
  function handleKeyPress (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSubmit()
    }
  }

  const handleBackToLoginPage = () => {
    navigate('/login')
  }

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        <div
          className='login-left flex-center flex-d-column'
          style={{
            backgroundImage: `url('${CDN_URL}/workshop-portal/static-images/login-bg.svg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '326px'
          }}
        >
          <div className='font-weight-700 gp-text24 text-white tracking-0 gp-lh28 gp-mb20'>{t('pageTitle')}</div>
          <p>
            {t('pageSubtitle')}
          </p>
        </div>
        {steps === 1 &&

          <CardContent className='login-right' style={{ height: '326px' }}>
            <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>{t('forgotPasswordText')}</h2>
            <p className='subheading'>
              {t('forgotPWDInfo')}
            </p>

            <div className='form-group'>
              <Label htmlFor='email' className='required'>{t('enterEmailAddress')}</Label>
              <Input
                id='email'
                name='email'
                className='gp-mt8'
                type='email' placeholder={t('yourEmailAddress')} onChange={handleChange}
                handleKeyPress={handleKeyPress}
              />
              <span style={errorStyle}>{error || ''}</span>
            </div>

            <Button
              className='login-button bg-[#6926D9] gp-mt12'
              disabled={!emailId}
              onClick={handleSubmit}
            >{t('resetPwd')}
            </Button>

            <p className='password-reset'>
              <a href='/login'>{t('backToLogin')}</a>
            </p>
          </CardContent>}

        {steps === 2 &&
          <CardContent className='login-right d-flex flex-d-column justify-content-center' style={{ height: '326px' }}>
            <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>
              <span
                style={{
                  userSelect: 'none',
                  width: '20px',
                  height: '20px',
                  display: 'inline-block',
                  fill: 'rgb(255, 255, 255)',
                  color: 'rgb(255, 255, 255)',
                  flexShrink: 0,
                  marginRight: '10px'
                }}
                dangerouslySetInnerHTML={{ __html: mailCheck }}
              />
              {t('passwordResetLinkSent')}
            </h2>
            <p className='subheading'>
              {t('accountLinkedText')} {emailId}, {t('receivedEmail')}
            </p>
            <Button
              className='login-button bg-[#6926D9]'
              onClick={handleBackToLoginPage}
            >{t('backToLogin')}
            </Button>
          </CardContent>}
      </Card>
    </div>
  )
}
